import React from 'react';
import {
  majorScale,
  Button,
  Popover,
  Menu,
  Position,
  ChevronDownIcon,
  SortIcon,
} from 'evergreen-ui';
import PropTypes from 'prop-types';

const OrderByMenu = ({ selected, setSelected }) => {
  const handleSelect = (value) => {
    if (setSelected && selected === value) {
      setSelected(null);
      return;
    }
    setSelected(value);
  };

  const isSelected = (value) => selected === value;

  return (
    <Popover
      position={Position.BOTTOM_RIGHT}
      content={(
        <Menu>
          <Menu.Group>
            <Menu.Option onSelect={() => handleSelect('title:asc')} isSelected={isSelected('title:asc')}>
              Title (asc)
            </Menu.Option>
            <Menu.Option onSelect={() => handleSelect('created_at:asc')} isSelected={isSelected('created_at:asc')}>
              Created date (asc)
            </Menu.Option>
            <Menu.Option onSelect={() => handleSelect('created_at:desc')} isSelected={isSelected('created_at:desc')}>
              Created date (desc)
            </Menu.Option>
            <Menu.Option onSelect={() => handleSelect('updated_at:asc')} isSelected={isSelected('updated_at:asc')}>
              Updated date (asc)
            </Menu.Option>
            <Menu.Option onSelect={() => handleSelect('updated_at:desc')} isSelected={isSelected('updated_at:desc')}>
              Updated date (desc)
            </Menu.Option>
          </Menu.Group>
        </Menu>
      )}>
      <Button
        iconBefore={SortIcon}
        iconAfter={ChevronDownIcon}
        marginRight={majorScale(1)}>
        Order by
      </Button>
    </Popover>
  );
};

OrderByMenu.propTypes = {
  selected: PropTypes.string,
  setSelected: PropTypes.func,
};

export default OrderByMenu;
